import { useMemo } from 'react'
import { Avatar, Flex, Skeleton } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import Text from 'shared/components/typography/Text'
import Title from 'shared/components/typography/Title'
import { getAvatarUrl } from 'shared/utils/assets'
import s from './s.module.css'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'

function Header() {
  const { config, username, isLoading } = useStreamerConfigContext()
  const { avatar, welcome_msg: welcomeMsg } = config || {}
  const avatarUrl = useMemo(() => getAvatarUrl(avatar), [avatar])

  return (
    <Flex gap={16}>
      {isLoading ? (
        <Skeleton active paragraph={{ rows: 1 }} avatar={{ shape: 'square', size: 56 }} />
      ) : (
        <>
          <Avatar
            shape="square"
            size={56}
            alt={username}
            src={avatarUrl}
            className={s.avatar}
            icon={<UserOutlined />}
          />
          <Flex vertical gap={4} className={s.breakWord}>
            <Title level={1} fontSize={1} fontType="header">
              {username}
            </Title>
            <Text fontSize={16} fontType="body">
              {welcomeMsg}
            </Text>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default Header
